import { FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as api from '../../../../../api/generated';
import { KendoLoading } from '../../../../../components';
import ListItemCreateButton from '../../../../../components/custom/ListItemCreateButton';
import { useFetchedValue } from '../../../../../components/hooks/useFetched';
import { usePageableGrid } from '../../../../../components/hooks/usePageableGrid';
import { Grid, GridColumn } from '../../../../../components/KendoReact/Grid';
import { useWindow } from '../../../../../components/windows/WindowContext';
import AdministrationActionCell from '../../components/AdministrationActionCell';
import QueueCreateModalWindow from './QueueCreateModalWindow';
import QueueEditModalWindow from './QueueEditModalWindow';

const getQueues = async (organizationInformationId: number, skip: number, take: number) =>
    api.administration.getQueues({
        organizationInformationId,
        skip,
        take
    });

const QueuesList: FC = () => {
    const { openWindow } = useWindow();
    const [isLoading, setIsLoading] = useState(false);
    const { organizationInformationId } = useParams<'organizationInformationId'>();
    const [gridPageProps] = usePageableGrid([5, 10, 15, 20, 25], 15);

    const [queues, refetchQueues, , , isQueuesLoading] = useFetchedValue(
        getQueues,
        true,
        parseInt(organizationInformationId.toString()),
        gridPageProps.skip,
        gridPageProps.take
    );

    const openQueueEditModalWindow = async (queueId: number) => {
        try {
            QueueEditModalWindow.defaultProps = {
                componentProps: {
                    queueId: queueId,
                    organizationInformationId: parseInt(organizationInformationId.toString()),
                    refetchQueues: refetchQueues
                }
            };
            openWindow({
                title: 'Eilės redagavimas',
                component: QueueEditModalWindow,
                isDialogBehaviour: true,
                width: 1200,
                height: 780
            });
        } catch (ex) {
            toast.error(ex.error[0]);
        }
    };

    const openQueueCreateModalWindow = async () => {
        try {
            QueueCreateModalWindow.defaultProps = {
                componentProps: {
                    refetchQueues: refetchQueues
                }
            };
            openWindow({
                title: 'Eilės kūrimas',
                component: QueueCreateModalWindow,
                isDialogBehaviour: true,
                width: 1200,
                height: 780
            });
        } catch (ex) {
            toast.error(ex.error[0]);
        }
    };

    const deleteQueue = async (id: number) => {
        try {
            setIsLoading(true);
            await api.administration.deleteQueue(id);
            refetchQueues();
            toast.success('Eilė sėkmingai ištrinta');
        } catch (ex) {
            setIsLoading(false);
            toast.error('Eilės ištrinti nepavyko, sistemos klaida');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {isLoading ? (
                <KendoLoading />
            ) : (
                <>
                    <ListItemCreateButton openCreateModal={openQueueCreateModalWindow} />
                    <Grid selectedField="checked" className="mt-2" {...gridPageProps} data={queues} isLoading={isQueuesLoading}>
                        <GridColumn
                            width={200}
                            title="Veiksmai"
                            cell={(c) => (
                                <AdministrationActionCell
                                    {...c}
                                    fetchData={refetchQueues}
                                    deleteItem={deleteQueue}
                                    editItem={openQueueEditModalWindow}
                                />
                            )}
                        />
                        <GridColumn title="Pavadinimas" field="name" />
                    </Grid>
                </>
            )}
        </>
    );
};

export default QueuesList;
